import { Center, Icon, Text } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

const OffersNotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Center mx={{ base: '2', laptop: '8' }} mt={{ base: '4', laptop: '24' }}>
      <Icon name="GeneralActionsCloseOrRemove" boxSize="50" color="gray.800" />
      <Text ml="4" textStyle={{ base: 'h6Headline', laptop: 'h4Headline' }}>
        {t('No offers found')}
      </Text>
    </Center>
  );
};

export default OffersNotFound;
